import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DesiriGaanaSearch from "./desiri-gaana-search";
import DesiriGaanaTable from "./desiri-gaana-table";
import gaanaService from "../../services/desiriGaana/gaanaservice";
import { BreadCrumb } from "primereact/breadcrumb";

const DesiriGaanaPage: React.FC = () => {
  const { t } = useTranslation();
  const [filtered, setFiltered] = useState<any[]>([]);
  const [searchText, setSearchText] = useState("");
  const [gaanaData, setGaanaData] = useState([]);

  const fetchData = async () => {
    try {
      const res = await gaanaService.getAllGaanas();
      setGaanaData(res);
    } catch (error) {
      console.error("Error loading Gaana data:", error);
    }
  };
  const breadcrumbItems = [
    { label: "Desiri Master Data", url: "" },
    { label: "Add Gaana", url: "" },
  ];
  const home = { icon: "pi pi-home", url: "/" };

  const handleSearch = (text: string) => {
    const terms = text.toLowerCase().trim().split(/\s+/);
    const filteredResults = gaanaData.filter((g) =>
      terms.every((t) => Object.values(g).join(" ").toLowerCase().includes(t))
    );
    setFiltered(filteredResults);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    handleSearch(searchText);
  }, [searchText, gaanaData]);

  return (
    <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
      <div className="col-12">
        <h4 className="ml-1 mb-0">{t("Add Gaana")}</h4>
      </div>
      {/* <BreadCrumb
        model={breadcrumbItems}
        home={home}
        className=" mb-2 bg-transparent px-0 py-0 text-sm  text-gray-600"
        style={{
          border: "none",
          boxShadow: "none",
          background: "transparent",
          marginLeft: "11px",
        }}
      /> */}
      <DesiriGaanaSearch onSearch={setSearchText} onRefresh={fetchData} />
      <DesiriGaanaTable data={filtered} onRefresh={fetchData} />
    </div>
  );
};

export default DesiriGaanaPage;
